import { render, staticRenderFns } from "./LoginDealIndex.vue?vue&type=template&id=c6387cc0&scoped=true&"
import script from "./LoginDealIndex.vue?vue&type=script&lang=js&"
export * from "./LoginDealIndex.vue?vue&type=script&lang=js&"
import style0 from "./LoginDealIndex.vue?vue&type=style&index=0&id=c6387cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6387cc0",
  null
  
)

export default component.exports